import { useContext } from "react";
import Moment from "react-moment";
import { ResourceContext } from "../Service/Context/ResourceContext";

const SubjectDate = ({ subject, date }) => {
  const { contact } = useContext(ResourceContext);
  let styles = {
    subject: {
      fontSize: 20,
      fontWeight: 800,
      marginBottom: 10,
      flex: "1 1 280px",
      minWidth: 0,
    },
    dateContainer: {
      display: "flex",
      alignSelf: "center",
      flex: "1 1 260px",
      minWidth: 0,
      justifyContent: "flex-end",
      flexWrap: "wrap",
      columnGap: 4,
      rowGap: 2,
      textAlign: "right",
    },
    city: {
      minWidth: 0,
      maxWidth: "100%",
      overflowWrap: "anywhere",
      wordBreak: "break-word",
    },
    date: {
      whiteSpace: "nowrap",
    },
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        marginTop: 30,
        rowGap: 8,
      }}
    >
      <div
        style={styles.subject}
        dangerouslySetInnerHTML={{ __html: subject }}
      />
      <div style={styles.dateContainer}>
        {contact && contact.city && (
          <div style={styles.city}>{contact.city}{date ? "," : ""}</div>
        )}
        {date && (
          <div style={styles.date}>
            <Moment format="L">{date}</Moment>
          </div>
        )}
      </div>
    </div>
  );
};

export default SubjectDate;
